import React from "react";
import styles from "./Tabs.module.css";

const Tabs = ({ itemsTab, tabSelect, setTabSelect }) => {
    const selectTab = (idTab) => {
        setTabSelect(idTab);
    }

    return (
        <React.Fragment>
            <div className={styles.tab_head}>
            {itemsTab.map((tab, index) => (
                <div key={'tab_' + index} className={`${styles.tab_title} ${tabSelect === tab.id ? styles.tab_title_select : null}`} onClick={() => selectTab(tab.id)}>
                    <span className={styles.tab_title_span}>
                        {tab.descripcion}
                    </span>
                </div>
            ))}
            </div>
            <div className={styles.tab_body}>
                {itemsTab.map((tabBody, index) => (
                    <React.Fragment key={'body_' + index}>
                    {tabSelect === tabBody.id
                        ? tabBody.componente
                        : null
                    }
                    </React.Fragment>
                ))}
            </div>
        </React.Fragment>
    )
}

export default Tabs;